import {
  getAttributesServer,
  getConnectTime,
  getCredentials,
  getCustomerDevice,
  getDeviceKey,
  getDevicesInfo
} from "../until/api/MeteSoil";

export default {
  /**
   * 判断用户等级
   * @param authority
   * @param customerId
   * @param callback
   * @returns {Promise<unknown>}
   */
  getDeviceList(authority, customerId, callback) {
    return new Promise(resolve => {
      if(authority == 'TENANT_ADMIN') {
        getDevicesInfo().then(response => {
          callback(response.data);
        }). catch(error => {
          console.log("error",error)
        })
      } else {
        getCustomerDevice(customerId).then(response => {
          callback(response.data)
        }).catch(error => {
          console.log("error", error);
        })
      }
    })
  },

  /**
   * 获取设备属性
   * @param deviceId
   * @param callback
   */
  getDeviceKeyList(deviceId, callback) {
    getDeviceKey(deviceId.entityType, deviceId.id).then(response=> {
      let deviceKey = '';
      let pattern = /^[A-Za-z0-9.-_]+$/;
      for (let i = 0; i <= response.data.length - 1; i++) {
        if (pattern.test(response.data[i])) {
          i === response.data.length - 1 ? deviceKey += response.data[i] : deviceKey += response.data[i] + ','
        }
      }
      callback(deviceKey);
    }).catch(error => {
      console.log("error",error)
    })
  },

  /**
   * 获取最后一次连接时间
   * @param entityType
   * @param deviceId
   * @param callback
   */
  getLastConnectTime(entityType, deviceId) {
    return new Promise((resolve, reject) => {
      getConnectTime(entityType, deviceId).then(response => {
        if (response.data.length > 0) {
          resolve(response.data[0].lastUpdateTs);
        } else {
          resolve(null); // 如果没有数据，返回 null
        }
      }).catch(error => {
        console.log("error", error);
        reject(new Error(error));
      })
    })
  },

  /**
   * 获取用户服务端数据
   * @param customerId
   * @param callback
   */
  getCustomerData(customerId, callBack) {
    getAttributesServer('CUSTOMER', customerId).then(response => {
      callBack(response);
    }).catch(error => {
      console.log("error", error);
    })
  },

  /**
   * 获取设备Id
   * @param device
   * @param callback
   */
  getCredentialsInfo(device, callback) {
    getCredentials(device).then(response => {
      callback(response.data.deviceId);
    }).catch(error => {
      console.log("error",error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/tool/MeteSoilCommon.js